import { render, staticRenderFns } from "./step7.vue?vue&type=template&id=15c8ec78&scoped=true"
import script from "./step7.vue?vue&type=script&lang=ts"
export * from "./step7.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8ec78",
  null
  
)

export default component.exports